import React, { useEffect } from "react";
import { Form, Button, Input, DatePicker } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormItem from "../../../../components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";



function WorkExperienceList({
    name = "work_experience",
    label = "Work Experience",
    dataList = [],
    minItems = 1,
    maxItems,
    addButtonClass,
    mode = "edit",
    labelExtra,
    icon: Icon,
    listClass = "list-1-column",
    applicantId,
}) {
    const form = Form.useFormInstance();

    const emptyExperience = {
        wxp_id: 0,
        wxp_applicant_id: applicantId || null,
        wxp_company_name: "",
        wxp_position_title: "",
        wxp_date_from: null,
        wxp_date_to: null,
        wxp_summary: "",
    };

    const initialData = dataList && dataList.length > 0
            ? dataList
            : [emptyExperience];

    useEffect(() => {
        if (form && mode !== "view") {
            const currentValues = form.getFieldValue(name);

            if (!currentValues || currentValues.length === 0) {
                form.setFieldValue(name, [emptyExperience]);
            }
        }
    }, [form, name, mode]);

    return (
        <Form.List
            name={name}
            initialValue={[initialData]}
            rules={[
                requiredField(),
                {
                    validator: async (_, value) => {
                        if (!value || value.length < minItems) {
                            return Promise.reject(
                                new Error(
                                    `At least ${minItems} work experience${
                                        minItems > 1 ? "s" : ""
                                    } required`
                                )
                            );
                        }

                        return Promise.resolve();
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>
                    <div className="flex items-center gap-1 mb-2">
                        {Icon && <Icon className="w-4 h-4" />}
                        <span className="text-sm">{label}</span>
                        {labelExtra}
                    </div>

                    <div className={`gap-3 mb-3 ${listClass}`}>
                        {fields.map(({ key, name: fieldName, ...restField }, index) => {

                            return (
                                <div
                                    key={key}
                                    className="border rounded-lg p-4 mb-3"
                                >
                                    <div className="flex justify-between items-center">

                                        {mode === "edit" && fields.length > minItems && (
                                            <MinusCircleOutlined
                                                className="text-gray-500 dark:text-white cursor-pointer"
                                                onClick={() => remove(fieldName)}
                                            />
                                        )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <FormItem
                                            name={[fieldName, "wxp_id"]}
                                            hidden
                                        >
                                            <Input type="hidden"/>
                                        </FormItem>
                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "wxp_position_title"]}
                                            label="Job Title / Position"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="input-field"
                                                placeholder="Enter job title"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "wxp_company_name"]}
                                            label="Company Name"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="input-field"
                                                placeholder="Enter company name"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "wxp_date_from"]}
                                            label="Start Date"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="w-full input-field"
                                                placeholder="Enter start date"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "wxp_date_to"]}
                                            label="End Date"
                                        >
                                            <Input
                                                className="w-full input-field"
                                                placeholder="Enter end date"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>
                                    </div>

                                    <FormItem
                                        {...restField}
                                        name={[fieldName, "wxp_summary"]}
                                        label="Responsibilities / Description"
                                    >
                                        <Input.TextArea
                                            rows={4}
                                            className="input-field"
                                            placeholder="Describe responsibilities, achievements, or role details"
                                            readOnly={mode !== "edit"}
                                        />
                                    </FormItem>
                                </div>
                            );
                        })}
                    </div>

                    <Form.ErrorList errors={errors} className="mb-2 text-red-500" />

                    {mode === "edit" && (!maxItems || fields.length < maxItems) && (
                        <FormItem>
                            <Button
                                type="dashed"
                                onClick={() => add(emptyExperience)}
                                icon={<PlusOutlined />}
                                className={addButtonClass}
                            >
                                Add work experience
                            </Button>
                        </FormItem>
                    )}
                </>
            )}
        </Form.List>
    );
}

export default WorkExperienceList;